import type { GameModule } from '../types';
import Page from './Page';

const carrom: GameModule = {
  id:          'carrom',
  displayName: 'Carrom',
  tag:         'Board',
  theme: {
    gradient: 'from-cyan-400 to-blue-900',
    emoji:    '🎯',
    logo:     '/games/carrom/Logo.png',
  },
  // Carrom Board.png is a square; the lobby stack + score chips
  // sit vertically above and below — only portrait fits both.
  orientation: 'portrait',
  Page,
  adminIcon: 'sports_esports',
  adminTheme: {
    headerFrom:  'from-blue-950',
    headerTo:    'to-cyan-700',
    ring:        'ring-cyan-400',
    accent:      'bg-cyan-500',
    accentHover: 'hover:bg-cyan-400',
    dot:         'bg-cyan-400',
    softBg:      'bg-blue-950/40',
    rangeAccent: 'accent-cyan-400',
    badgeClasses: 'bg-cyan-500/20 text-cyan-200 border-cyan-400/30',
  },
};

export default carrom;
